import AvalanchePathImagesEditModal from '@components/AvalanchePathsAdmin/Images/AvalanchePathImagesEditModal';
import { Button, Col, FormLabel, Row } from 'react-bootstrap';
import Table from '@components/table';
import React, { useEffect, useState } from 'react';
import Authorize from '@components/Authorize';
import { Permissions } from '@awp/constants';
import AwpYesNoModal from '@components/Common/AwpYesNoModal';
import AvalanchePathImagesService, {
  AvalanchePathImagesDTO,
} from '@components/AvalanchePathsAdmin/Images/AvalanchePathImagesService';
import AvalanchePathImagesCreateModal from '@components/AvalanchePathsAdmin/Images/AvalanchePathImagesCreateModal';
import { useAvalanchePathImagesContext } from '@components/AvalanchePathsAdmin/Images/AvalanchePathImagesContext';
import AwpValidationErrorModal from '@components/Common/AwpValidationErrorModal';

const AvalanchePathImagesList = (props: any) => {
  const { readOnly, mode, ...rest } = props;

  const {
    parentEntityId,
    entity,
    setEntity,
    mediaEntities,
    filteredData,
    search,
    eventErrors,
    setMediaEntities,
    setFilteredData,
    setSearchParams,
    setSearch,
    setEventErrors,
    showEditModal,
    setShowEditModal,
    showDeleteModal,
    setShowDeleteModal,
    showCreateModal,
    setShowCreateModal,
    onHideEdit,
    onHandleEdit,
    onHideCreate,
    onHandleCreate,
    onDelete,
  } = useAvalanchePathImagesContext();

  const [loading, setLoading] = useState(false);

  const avalanchePathImagesService = new AvalanchePathImagesService();

  useEffect(() => {
    if (!parentEntityId) return;

    setLoading(true);

    // TODO: Move outside of the list page. Can be passed in
    AvalanchePathImagesService.getAvalanchePathImages(parentEntityId).then(
      (avalancheImages: AvalanchePathImagesDTO[]) => {
        setMediaEntities(avalancheImages);
        setLoading(false);
      },
    );
  }, [parentEntityId]);

  useEffect(() => {
    setFilteredData(avalanchePathImagesService.filterData(mediaEntities, null, search));
  }, [mediaEntities, search]);

  return (
    <>
      <Row>
        <Col className="mb-3">
          {avalanchePathImagesService.getFilters({ setSearchParams, search, setSearch })}
          {
            //@ts-expect-error: TODO - Set unused properties to undefined
            <Table
              columns={avalanchePathImagesService.getColumns({ setShowEditModal, setEntity, setShowDeleteModal, mode })}
              data={filteredData}
              fetchData={() => {
                /* Do Nothing */
              }}
              loading={loading}
              defaultSortBy={'Last Updated'}
              defaultDesc={true}
            />
          }
        </Col>
      </Row>
      <Row>
        <Col>
          <Authorize requires={[Permissions.WriteAdminTools]}>
            <Button
              className="mr-2 mr-mini-0 float-left"
              variant="primary"
              onClick={() => {
                setShowCreateModal(true);
              }}
              disabled={loading}
            >
              Create
            </Button>
          </Authorize>
        </Col>
      </Row>
      {showCreateModal && (
        <AvalanchePathImagesCreateModal
          visible={showCreateModal}
          onHide={onHideCreate}
          onSave={onHandleCreate}
          setEventErrors={setEventErrors}
        />
      )}
      {showEditModal && (
        <AvalanchePathImagesEditModal
          visible={showEditModal}
          entity={entity}
          mode={mode} // TODO: Split modal into View and Edit
          onHide={onHideEdit}
          onSave={onHandleEdit}
          onDelete={onDelete}
          setEventErrors={setEventErrors}
        />
      )}
      {showDeleteModal && (
        <AwpYesNoModal
          showYesNoModal={showDeleteModal}
          setShowYesNoModal={setShowDeleteModal}
          onClickYes={onDelete}
          title="Delete"
          body="Are you sure you want to delete?"
        />
      )}
      <AwpValidationErrorModal setErrors={setEventErrors} errors={eventErrors} />
    </>
  );
};

export default AvalanchePathImagesList;
